var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.396,
    height: 19.155,
    viewBox: "0 0 26.396 19.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-role",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1.955,18.782H3.32V24.7a.455.455,0,0,0,.455.455H9.237a.455.455,0,0,0,.455-.455v-1.82a.455.455,0,1,0-.91,0v1.365H6.961V19.237a.455.455,0,1,0-.91,0v5.006H4.231V15.6a.455.455,0,1,0-.91,0v2.275H2.41V15.6A3.18,3.18,0,0,1,5.6,12.41h1.82A3.18,3.18,0,0,1,10.6,15.6v2.275h-.91V15.6a.455.455,0,1,0-.91,0v3.641a.455.455,0,1,0,.91,0v-.455h1.365a.455.455,0,0,0,.455-.455V15.6a4.091,4.091,0,0,0-4.1-4.1H5.6a4.091,4.091,0,0,0-4.1,4.1v2.731a.455.455,0,0,0,.455.455Z",
    transform: "translate(-1.5 -5.997)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M6.775,10.051A2.275,2.275,0,1,0,4.5,7.775a2.275,2.275,0,0,0,2.275,2.275Zm0-3.641A1.365,1.365,0,1,1,5.41,7.775,1.365,1.365,0,0,1,6.775,6.41Z",
    transform: "translate(-1.769 -5.459)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M17.6,9.692a4.1,4.1,0,1,0-4.1-4.1,4.1,4.1,0,0,0,4.1,4.1Zm0-7.282A3.186,3.186,0,1,1,14.41,5.6,3.186,3.186,0,0,1,17.6,2.41Z",
    transform: "translate(-2.578 -1.5)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M17.6,29.692a4.1,4.1,0,1,0-4.1-4.1A4.1,4.1,0,0,0,17.6,29.692Zm0-7.282A3.186,3.186,0,1,1,14.41,25.6,3.186,3.186,0,0,1,17.6,22.41Z",
    transform: "translate(-2.578 -11.695)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M17.044,7.1a.455.455,0,0,0,.644,0l1.82-1.82a.455.455,0,1,0-.644-.644l-1.5,1.5-.588-.588a.455.455,0,1,0-.644.644Z",
    transform: "translate(-2.802 -1.769)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M16.633,27.1a.455.455,0,0,0,.644,0l.588-.588.588.588a.455.455,0,1,0,.644-.644l-.588-.588.588-.588a.455.455,0,1,0-.644-.644l-.588.588-.588-.588a.455.455,0,1,0-.644.644l.588.588-.588.588a.455.455,0,0,0,0,.644Z",
    transform: "translate(-2.847 -11.964)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M29.416,3.5H23.955a.455.455,0,1,0,0,.91h5.461a.455.455,0,1,0,0-.91Z",
    transform: "translate(-3.476 -1.68)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M29.416,5.5H23.955a.455.455,0,1,0,0,.91h5.461a.455.455,0,1,0,0-.91Z",
    transform: "translate(-3.476 -1.859)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M23.955,8.41H27.6a.455.455,0,1,0,0-.91H23.955a.455.455,0,1,0,0,.91Z",
    transform: "translate(-3.476 -2.039)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M29.416,23.5H23.955a.455.455,0,0,0,0,.91h5.461a.455.455,0,0,0,0-.91Z",
    transform: "translate(-3.476 -11.874)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M29.416,25.5H23.955a.455.455,0,0,0,0,.91h5.461a.455.455,0,0,0,0-.91Z",
    transform: "translate(-3.476 -12.054)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M27.6,27.5H23.955a.455.455,0,0,0,0,.91H27.6a.455.455,0,1,0,0-.91Z",
    transform: "translate(-3.476 -12.234)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.455,
    cy: 0.455,
    r: 0.455,
    transform: "translate(7.282 18.204)",
    fill: "#696969"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIcon);
export default __webpack_public_path__ + "static/media/roleIcon.a238f7263795c6f557733d08d8cd520c.svg";
export { ForwardRef as ReactComponent };